const getResultsTableTitle = (isFlightSelected, canExchange) => {
  if (isFlightSelected) {
    return I18n.t('components.ibe.results.flight_selected');
  }

  if (canExchange) {
    return I18n.t('components.ibe.results.available_flights');
  }

  return I18n.t('components.ibe.results.flight_select');
};

export default getResultsTableTitle;
